import React from 'react'
import Card from '../../../common/Card'
import ReactHighcharts from 'react-highcharts';
import HighchartsMore from 'highcharts-more';
import Pareto from 'highcharts/modules/pareto';
import SolidGauge from 'highcharts/modules/solid-gauge';
import Highcharts from "@material-ui/core/es/styles/withStyles";

HighchartsMore(ReactHighcharts.Highcharts);
Pareto(ReactHighcharts.Highcharts);
SolidGauge(ReactHighcharts.Highcharts);

// Radialize the colors

var configBarra = {
        chart: {
            type: 'column',
            zoomType: 'x'
        },
        legend: {
            enabled: true
        },
        title: {
            text: 'Fabricante'
        },
        xAxis: {
            categories: [],
            title: {
                text: ''
            }
        },
        plotOptions: {
            pareto: {
                marker: {
                    enabled: false
                }
            },
            column: {
                stacking: 'normal',
                dataLabels: {
                    enabled: true,
                    color: 'blue',
                    format: '{point.y:.0f}',
                    rotation: 270
                }
            }
        },
        yAxis: [{
            title: {
                text: ''
            }
        }, {
            title: {
                text: ''
            },
            minPadding: 0,
            maxPadding: 0,
            max: 100,
            min: 0,
            opposite: true,
            labels: {
                format: "{value}%"
            }
        }],
        series: [{
            type: 'pareto',
            name: 'Pareto',
            yAxis: 1,
            zIndex: 10,
            baseSeries: 1
        }, {
            type: 'column',
            zIndex: 2,
            name: 'Fabricante',
            data: []
        }]
    };


var configPie = {
    chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
    },
    title: {
        enabled : false,
        text: 'Fabricantes'
    },

    tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    accessibility: {
        point: {
            valueSuffix: '%'
        }
    },
    plotOptions: {
        pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            size: '100%',
            dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.percentage:.1f} %',
                connectorColor: 'silver',
                distance: 10,
                style: {
                    fontSize: "9px",
                    fontWeight: "normal"
                }
            }
        }
    }

}


export default function TireBrandsParetoChart(prop) {
    const { series } = prop;

    // Highcharts.setOptions({
    //     colors: Highcharts.map(Highcharts.getOptions().colors, function (color) {
    //         return {
    //             radialGradient: {
    //                 cx: 0.5,
    //                 cy: 0.3,
    //                 r: 0.7
    //             },
    //             stops: [
    //                 [0, color],
    //                 [1, Highcharts.color(color).brighten(-0.3).get('rgb')] // darken
    //             ]
    //         };
    //     })
    // });


    /*
    if (series) {
        let categories = [];
        let bTotal = [];

        series.map(i => {
            categories.push(i.descricao);
            bTotal.push( i.total );

        })

        config = {
            ...config,
            xAxis: {
                categories: categories,
                title: {
                    text: ''
                }
            },

            series: [{
                type: 'pareto',
                name: 'Pareto',
                yAxis: 1,
                zIndex: 10,
                baseSeries: 1
            }, {
                type: 'column',
                zIndex: 2,
                name: 'Fabricante',
                data: bTotal
            }]
        }

    }
*/
    if (series) {
      let valores = [];
      let outros = 0;

      let soma = 0;
        series.map( s => {
            soma = soma + s.total;
        })

      series.map( s => {
          if (s.total < soma * 0.01) {
              outros = outros + s.total;
          } else {
              valores.push({name: s.descricao, y: s.total, description: s.total + 'un'});
          }
      })

        if (outros > 0) {
            valores.push({name: 'OUTROS', y: outros, description: outros + 'un'});
        }

        configPie = {
          ...configPie,
            series: [{
                name: 'Fabricante',
                data: valores
            }]
        }
    }


    return (
        <Card>
            <ReactHighcharts config = {configPie}>
            </ReactHighcharts>
        </Card>
    )
}
